<template>
    <article id="c66076ae-9a28-41e0-b537-e88775435853" class="page sans">
        <div class="page-body">
            <p id="9ca566f7-6992-4396-bbde-799142ebdbd0" class="">
                El uso de sitio Web implica la aceptación de esta Política de Privacidad.
            </p>
            <p id="2e12a679-e471-4598-9a86-f5d42dd1c1e4" class="">
                {{companyName}} te informa sobre su Política de Privacidad respecto del tratamiento y protección de los datos de carácter 
                personal de los usuarios y clientes que puedan ser recabados por la navegación o contratación de servicios a través del sitio Web 
               {{companyUrl}} . {{companyName}} está comprometida con la seguridad de los datos de sus usuarios. 
               Cuando solicitamos completar los campos de información personal con la cual podrás ser identificado, 
               lo hacemos asegurando que solo se empleará de acuerdo con los términos de este documento. 
            </p>
            <p id="51633388-b71e-41c6-b462-019d1102d243" class="">
                Esta Política de Privacidad puede cambiar con el tiempo o ser actualizada por lo que recomendamos revisarla con 
                frecuencia para asegurarte que estés de acuerdo con los cambios.
            </p>
            <h3 id="77543349-03a1-4177-a51a-3f4d2c92abc4" class="">Obtención de datos personales</h3>
            <p id="c2842e46-4480-4e6c-b709-1a277e2774ce" class="">
                Para navegar por {{companyUrl}} no es necesario que facilites ningún dato personal. Los casos en los que sí proporcionas 
                tus datos personales son los siguientes:
            </p>
            <ul id="0bfa3bd9-efe8-42c0-9104-68ff49f21e3f" class="bulleted-list">
                <li>Al contactar a través de los formularios de contacto o enviar un correo electrónico.</li>
            </ul>
            <ul id="6a6304b0-68d8-42fb-a398-ccc2cf2e5c71" class="bulleted-list">
                <li>Al realizar un comentario en un artículo o página.</li>
            </ul>
            <ul id="6066bf04-f1aa-43d2-8943-6a5aa300127f" class="bulleted-list">
                <li>Al crear una orden.</li>
            </ul>
            <ul id="4c686a1a-09ac-4741-b52f-21e569102b2e" class="bulleted-list">
                <li>Al realizar un pago.</li>
            </ul>
            <ul id="eb718e5c-7e94-43dd-9bb0-05371daf8a4c" class="bulleted-list">
                <li>Al registrarte como un usuario.</li>
            </ul>
            <h3 id="108d6208-8f0b-4ced-b815-a2804098d6b4" class="">Finalidad del tratamiento de datos personales</h3>
            <p id="113b21bb-0b97-461a-a2b6-d038b8738ade" class="">
                {{companyName}} no venderá, cederá ni distribuirá la información personal que es recopilada sin su consentimiento, 
                salvo que sea requerido por un juez con orden judicial.
            </p>
            <p id="43f80fe0-b3c5-43c4-99d2-5a2e1db10e42" class="">
                Al realizar una de esas acciones mencionadas arriba, estás facilitando información de carácter personal de la que el 
                responsable es {{companyName}}. Esta información puede incluir datos de carácter personal como pueden ser tu dirección 
                IP, nombre y apellidos, dirección física, dirección de correo electrónico, número de teléfono, y otra información. Al 
                facilitar esta información, das tu consentimiento para que tu información sea recopilada, utilizada, gestionada y 
                almacenada por {{companyUrl}} , sólo como se describe en la presente Política de Privacidad.
            </p>
            <p id="0ea1a35c-9aec-4446-9be6-9aa1d37ace44" class="">
                Los datos personales y la finalidad del tratamiento por parte del 
                Titular es diferente según el sistema de captura de información:
            </p>
            <ul id="c1205582-3c4f-42dc-b5de-9b18468f8ab3" class="bulleted-list">
                <li>
                    <strong>Formularios de contacto:</strong>
                    <p id="e3121fe2-c3aa-4e77-a578-2441d41dac26" class="">Se te solicita datos personales entre los que pueden estar: 
                        Nombre y apellidos, dirección de correo electrónico, número de teléfono y dirección de tu sitio Web con la 
                        finalidad de responder a tus consultas.</p><p id="e0e985d5-a983-4597-b0d2-6149852fa402" class="">Por ejemplo, 
                        el Titular utiliza esos datos para dar respuesta a tus mensajes, dudas, quejas, comentarios o inquietudes 
                        que puedas tener relativas a la información incluida en el sitio Web, los servicios que se prestan a través
                        del sitio Web, el tratamiento de tus datos personales, cuestiones referentes a los textos legales 
                        incluidos en el sitio Web, así como cualquier otra consulta que puedas tener y que no esté sujeta a las 
                        condiciones del sitio Web o de la contratación.
                    </p>
                </li>
            </ul>
            <ul id="65e19f58-08b8-4551-ba5a-0e190c62634b" class="bulleted-list">
                <li>
                    <strong>Formularios de suscripción a contenidos:</strong> 
                    <p id="ede94007-09bb-45ee-b123-74642b74e406" class="">
                        El Titular solicita los siguientes datos personales: 
                        Nombre y apellidos, dirección de correo electrónico, número de teléfono y dirección de tu sitio web para 
                        gestionar la lista de suscripciones, enviar boletines, promociones y ofertas especiales.
                    </p>
                </li>
            </ul>
            <ul id="8ed032ba-3262-459c-92ca-fae9460301a7" class="bulleted-list">
                <li>
                    <strong>Formularios de ordenes:</strong>
                    <p id="06bf2ea5-88c9-4c65-b115-3fab1a3116a6" class="">
                        Se te solicita datos personales entre los que pueden estar: Nombre y apellido, numero de documento de 
                        identidad, dirección de correo electrónico, y dirección física. 
                    </p>
                    <p id="7ecb13c1-bad2-4bf5-8bb7-5ec4e1f3f477" class="">
                        Estos datos son utilizados para poder hacer llegar los pedidos al comprador.
                    </p>
                </li>
            </ul>
            <!--
            <ul id="bb82124c-11a9-450b-8666-d5166bef6631" class="bulleted-list">
                <li>
                    <strong>Formularios de pagos:</strong>
                    <p id="075ece35-a2b1-46e2-8452-ce2476e33443" class="">
                        Cuando decides pagar usando una tarjeta, te vamos a solicitar la fecha de vencimiento, numero, cvc, 
                        nombre y apellido del titular, y numero de documento del titular.
                        Nosotros no almacenamos ninguno de esos datos en nuestros servidores, ya que nos apoyamos en el servicio de 
                        MercadoPago para poder tokenizar los mismos, usando todas sus librererias y recursos en todo momento.
                    </p>
                </li>
            </ul>
            -->
            <h3 id="df0ae562-96b5-48cf-8a10-4c9fcffaf816" class="">Seguridad de los datos personales</h3>
            <p id="ec946cc2-002b-4606-94b7-d037bab46694" class="">
                Para proteger tus datos personales, el Titular toma todas las precauciones razonables y sigue las mejores prácticas de
                 la industria para evitar su pérdida, mal uso, acceso indebido, divulgación, alteración o destrucción de los mismos.
            </p>
            <p id="6cd57b7d-dd18-47ae-9885-16c274ab5424" class="">
                El sitio Web está alojado en <strong>DigitalOcean</strong>. La seguridad de tus datos está garantizada, 
                ya que toman todas las medidas de seguridad necesarias para ello. Puedes consultar su política de privacidad 
                para tener más información.
            </p>
            <h3 id="853c55c2-a1e3-4427-8483-f108507cd2b5" class="">Principios aplicados en el tratamiento de datos</h3>
            <ul id="bae9abc5-8a24-4f34-8198-f4ed19a8743f" class="bulleted-list">
                <li>
                    <strong>Principio de licitud, lealtad y transparencia:</strong> 
                    El Titular siempre requerirá el consentimiento para el tratamiento de tus datos personales que puede ser 
                    para uno o varios fines específicos sobre los que te informará previamente con absoluta transparencia.
                </li>
            </ul>
            <ul id="fa6e33e9-d332-42ce-94ee-49bad1cc8b92" class="bulleted-list">
                <li>
                    <strong>Principio de minimización de datos:</strong>
                    El Titular te solicitará solo los datos estrictamente necesarios para el fin o los fines que los solicita.
                </li>
            </ul>
            <ul id="4fefa086-cf95-4f21-b275-2e00b2f3b403" class="bulleted-list">
                <li>
                    <strong>Principio de limitación del plazo de conservación:</strong> 
                    Los datos se mantendrán durante el tiempo estrictamente necesario para el fin o los fines del tratamiento.
                    El Titular te informará del plazo de conservación correspondiente según la finalidad. En el caso de suscripciones,
                    el Titular revisará periódicamente las listas y eliminará aquellos registros inactivos durante un tiempo 
                    considerable.
                </li>
            </ul>
            <ul id="1159f4bf-49c0-4eeb-82c5-02ad15c03abf" class="bulleted-list">
                <li>
                    <strong>Principio de integridad y confidencialidad:</strong> 
                    Tus datos serán tratados de tal manera que su seguridad, confidencialidad e integridad esté garantizada. Debes 
                    saber que el Titular toma las precauciones necesarias para evitar el acceso no autorizado o uso indebido de los 
                    datos de sus usuarios por parte de terceros.
                </li>
            </ul>
            <h3 id="13ba1742-1d14-496d-99eb-e9bd400afa6d" class="">Enlaces a Terceros</h3>
            <p id="096667a8-8ea0-431a-ad45-c5aa23bfe52a" class="">
                Este sitio web puede contener enlaces a otros sitios que pudiesen ser de tu interés. 
                Una vez que hace click en estos enlaces y abandona nuestra página, ya no tenemos control sobre el sitio al que es 
                redirigido y por lo tanto no somos responsables de los términos o privacidad ni de la protección de sus datos en esos 
                otros sitios terceros. Dichos sitios están sujetos a sus propias políticas de privacidad por lo cual es recomendable 
                que los consulte para confirmar que usted esté de acuerdo con éstas.
            </p>
            <h3 id="47a7554e-ea21-423d-a7e3-a5fa6b90c57d" class="">Categorías de datos personales</h3>
            <p id="259a0351-1c41-42eb-a83a-c050a57b9ef3" class="">
                Las categorías de datos personales que trata el Titular son:
            </p>
            <ul id="6a227712-239e-4309-ada6-663fe9779868" class="bulleted-list">
                <li>Datos identificativos.</li>
            </ul>
            <h3 id="4515a0ff-ed75-44a8-aa21-e1acf5df6873" class="">Conservación de datos personales</h3>
            <p id="112eeeaa-5cf1-4982-bc92-9bca7ea39b41" class="">
                Los datos personales que proporciones al Titular se conservarán hasta que solicites su supresión.
            </p>
            <h3 id="c357cf02-6c2d-4950-8dd0-a79f2d5a3689" class="">Navegación Web</h3>
            <p id="cff12eee-df37-420e-8d6f-030d727cbc0a" class="">
                Al navegar por {{companyUrl}} se pueden recoger datos no identificativos, que pueden incluir, la dirección IP, 
                geolocalización, un registro de cómo se utilizan los servicios y sitios, hábitos de navegación y otros datos que 
                no pueden ser utilizados para identificarte.
            </p>
            <p id="d49c4136-ca7f-4d30-bf37-5c55b47989ad" class="">El sitio Web utiliza los siguientes servicios de análisis de terceros:</p><ul id="c7fc3658-e387-4ba9-802b-2b82ebe4bbe1" class="bulleted-list"><li>Google Analytics</li></ul><ul id="1d49c329-e25a-4927-84b5-6f22859fee57" class="bulleted-list"><li>DoubleClick por Google</li></ul><p id="0b850995-5bd1-428f-8b45-dce72db1594e" class="">El Titular utiliza la información obtenida para obtener datos estadísticos, analizar tendencias, administrar el sitio, estudiar patrones de navegación y para recopilar información demográfica.</p><h3 id="949426a6-459a-4880-a1ef-e84c3c420fd4" class="">Exactitud y veracidad de los datos personales</h3><p id="578b79b6-a187-4902-a676-0f92273d5bdc" class="">Te comprometes a que los datos facilitados al Titular sean correctos, completos, exactos y vigentes, así como a mantenerlos debidamente actualizados.</p><p id="982f0e70-76cc-4274-ad4d-d9d170a6f2c9" class="">Como Usuario del sitio Web eres el único responsable de la veracidad y corrección de los datos que remitas al sitio exonerando a el Titular de cualquier responsabilidad al respecto.</p><h3 id="640432ec-6620-4a58-bf4e-ab0ed91e1c62" class="">Aceptación y consentimiento</h3><p id="a309f4c7-1aa0-4073-9c0c-8201293fe8c5" class="">Como Usuario del sitio Web declaras haber sido informado de las condiciones sobre protección de datos de carácter personal, aceptas y consientes el tratamiento de los mismos por parte de el Titular en la forma y para las finalidades indicadas en esta Política de Privacidad.</p><h3 id="a629a39a-c81a-4d86-88f6-0765690fa6ab" class="">Cambios en la Política de Privacidad</h3><p id="2f7ceeee-f7cc-46e6-b8d1-f0d5401e7687" class="">El Titular se reserva el derecho a modificar la presente Política de Privacidad para adaptarla a novedades legislativas o jurisprudenciales, así como a prácticas de la industria.</p><p id="fd201f44-06dd-467b-9c68-19ee6930e2f9" class="">Estas políticas estarán vigentes hasta que sean modificadas por otras debidamente publicadas.</p></div></article>
</template>

<script>
export default {
    props:{
        companyName:{
            type:String,
            default:"FYNMOST S.R.L"
        },
        companyUrl:{
            type:String,
            default:"traction.cloud"
        }
    }
}
</script>


<style lang="scss" scoped>
html {
	-webkit-print-color-adjust: exact;
}
* {
	box-sizing: border-box;
	-webkit-print-color-adjust: exact;
}

html,
body {
	margin: 0;
	padding: 0;
}
@media only screen {
	body {
		margin: 2em auto;
		max-width: 900px;
		color: rgb(55, 53, 47);
	}
}

body {
	line-height: 1.5;
	white-space: pre-wrap;
}

a,
a.visited {
	color: inherit;
	text-decoration: underline;
}

.pdf-relative-link-path {
	font-size: 80%;
	color: #444;
}

h1,
h2,
h3 {
	letter-spacing: -0.01em;
	line-height: 1.2;
	font-weight: 600;
	margin-bottom: 0;
}

.page-title {
	font-size: 2.5rem;
	font-weight: 700;
	margin-top: 0;
	margin-bottom: 0.75em;
}

h1 {
	font-size: 1.875rem;
	margin-top: 1.875rem;
}

h2 {
	font-size: 1.5rem;
	margin-top: 1.5rem;
}

h3 {
	font-size: 1.25rem;
	margin-top: 1.25rem;
}

.source {
	border: 1px solid #ddd;
	border-radius: 3px;
	padding: 1.5em;
	word-break: break-all;
}

.callout {
	border-radius: 3px;
	padding: 1rem;
}

figure {
	margin: 1.25em 0;
	page-break-inside: avoid;
}

figcaption {
	opacity: 0.5;
	font-size: 85%;
	margin-top: 0.5em;
}

mark {
	background-color: transparent;
}

.indented {
	padding-left: 1.5em;
}

hr {
	background: transparent;
	display: block;
	width: 100%;
	height: 1px;
	visibility: visible;
	border: none;
	border-bottom: 1px solid rgba(55, 53, 47, 0.09);
}

img {
	max-width: 100%;
}

@media only print {
	img {
		max-height: 100vh;
		object-fit: contain;
	}
}

@page {
	margin: 1in;
}

.collection-content {
	font-size: 0.875rem;
}

.column-list {
	display: flex;
	justify-content: space-between;
}

.column {
	padding: 0 1em;
}

.column:first-child {
	padding-left: 0;
}

.column:last-child {
	padding-right: 0;
}

.table_of_contents-item {
	display: block;
	font-size: 0.875rem;
	line-height: 1.3;
	padding: 0.125rem;
}

.table_of_contents-indent-1 {
	margin-left: 1.5rem;
}

.table_of_contents-indent-2 {
	margin-left: 3rem;
}

.table_of_contents-indent-3 {
	margin-left: 4.5rem;
}

.table_of_contents-link {
	text-decoration: none;
	opacity: 0.7;
	border-bottom: 1px solid rgba(55, 53, 47, 0.18);
}

table,
th,
td {
	border: 1px solid rgba(55, 53, 47, 0.09);
	border-collapse: collapse;
}

table {
	border-left: none;
	border-right: none;
}

th,
td {
	font-weight: normal;
	padding: 0.25em 0.5em;
	line-height: 1.5;
	min-height: 1.5em;
	text-align: left;
}

th {
	color: rgba(55, 53, 47, 0.6);
}

ol,
ul {
	margin: 0;
	margin-block-start: 0.6em;
	margin-block-end: 0.6em;
}

li > ol:first-child,
li > ul:first-child {
	margin-block-start: 0.6em;
}

ul > li {
	list-style: disc;
}

ul.to-do-list {
	text-indent: -1.7em;
}

ul.to-do-list > li {
	list-style: none;
}

.to-do-children-checked {
	text-decoration: line-through;
	opacity: 0.375;
}

ul.toggle > li {
	list-style: none;
}

ul {
	padding-inline-start: 1.7em;
}

ul > li {
	padding-left: 0.1em;
}

ol {
	padding-inline-start: 1.6em;
}

ol > li {
	padding-left: 0.2em;
}

.mono ol {
	padding-inline-start: 2em;
}

.mono ol > li {
	text-indent: -0.4em;
}

.toggle {
	padding-inline-start: 0em;
	list-style-type: none;
}

/* Indent toggle children */
.toggle > li > details {
	padding-left: 1.7em;
}

.toggle > li > details > summary {
	margin-left: -1.1em;
}

.selected-value {
	display: inline-block;
	padding: 0 0.5em;
	background: rgba(206, 205, 202, 0.5);
	border-radius: 3px;
	margin-right: 0.5em;
	margin-top: 0.3em;
	margin-bottom: 0.3em;
	white-space: nowrap;
}

.collection-title {
	display: inline-block;
	margin-right: 1em;
}

time {
	opacity: 0.5;
}

.icon {
	display: inline-block;
	max-width: 1.2em;
	max-height: 1.2em;
	text-decoration: none;
	vertical-align: text-bottom;
	margin-right: 0.5em;
}

img.icon {
	border-radius: 3px;
}

.user-icon {
	width: 1.5em;
	height: 1.5em;
	border-radius: 100%;
	margin-right: 0.5rem;
}

.user-icon-inner {
	font-size: 0.8em;
}

.text-icon {
	border: 1px solid #000;
	text-align: center;
}

.page-cover-image {
	display: block;
	object-fit: cover;
	width: 100%;
	height: 30vh;
}

.page-header-icon {
	font-size: 3rem;
	margin-bottom: 1rem;
}

.page-header-icon-with-cover {
	margin-top: -0.72em;
	margin-left: 0.07em;
}

.page-header-icon img {
	border-radius: 3px;
}

.link-to-page {
	margin: 1em 0;
	padding: 0;
	border: none;
	font-weight: 500;
}

p > .user {
	opacity: 0.5;
}

td > .user,
td > time {
	white-space: nowrap;
}

input[type="checkbox"] {
	transform: scale(1.5);
	margin-right: 0.6em;
	vertical-align: middle;
}

p {
	margin-top: 0.5em;
	margin-bottom: 0.5em;
}

.image {
	border: none;
	margin: 1.5em 0;
	padding: 0;
	border-radius: 0;
	text-align: center;
}

.code,
code {
	background: rgba(135, 131, 120, 0.15);
	border-radius: 3px;
	padding: 0.2em 0.4em;
	border-radius: 3px;
	font-size: 85%;
	tab-size: 2;
}

code {
	color: #eb5757;
}

.code {
	padding: 1.5em 1em;
}

.code > code {
	background: none;
	padding: 0;
	font-size: 100%;
	color: inherit;
}

blockquote {
	font-size: 1.25em;
	margin: 1em 0;
	padding-left: 1em;
	border-left: 3px solid rgb(55, 53, 47);
}

.bookmark {
	text-decoration: none;
	max-height: 8em;
	padding: 0;
	display: flex;
	width: 100%;
	align-items: stretch;
}

.bookmark-title {
	font-size: 0.85em;
	overflow: hidden;
	text-overflow: ellipsis;
	height: 1.75em;
	white-space: nowrap;
}

.bookmark-text {
	display: flex;
	flex-direction: column;
}

.bookmark-info {
	flex: 4 1 180px;
	padding: 12px 14px 14px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.bookmark-image {
	width: 33%;
	flex: 1 1 180px;
	display: block;
	position: relative;
	object-fit: cover;
	border-radius: 1px;
}

.bookmark-description {
	color: rgba(55, 53, 47, 0.6);
	font-size: 0.75em;
	overflow: hidden;
	max-height: 4.5em;
	word-break: break-word;
}

.bookmark-href {
	font-size: 0.75em;
	margin-top: 0.25em;
}

.sans { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"; }
.code { font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace; }
.serif { font-family: Lyon-Text, Georgia, YuMincho, "Yu Mincho", "Hiragino Mincho ProN", "Hiragino Mincho Pro", "Songti TC", "Songti SC", "SimSun", "Nanum Myeongjo", NanumMyeongjo, Batang, serif; }
.mono { font-family: iawriter-mono, Nitti, Menlo, Courier, monospace; }
.pdf .sans { font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol", 'Twemoji', 'Noto Color Emoji', 'Noto Sans CJK SC', 'Noto Sans CJK KR'; }

.pdf .code { font-family: Source Code Pro, "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK SC', 'Noto Sans Mono CJK KR'; }

.pdf .serif { font-family: PT Serif, Lyon-Text, Georgia, YuMincho, "Yu Mincho", "Hiragino Mincho ProN", "Hiragino Mincho Pro", "Songti TC", "Songti SC", "SimSun", "Nanum Myeongjo", NanumMyeongjo, Batang, serif, 'Twemoji', 'Noto Color Emoji', 'Noto Sans CJK SC', 'Noto Sans CJK KR'; }

.pdf .mono { font-family: PT Mono, iawriter-mono, Nitti, Menlo, Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK SC', 'Noto Sans Mono CJK KR'; }

.highlight-default {
}
.highlight-gray {
	color: rgb(155,154,151);
}
.highlight-brown {
	color: rgb(100,71,58);
}
.highlight-orange {
	color: rgb(217,115,13);
}
.highlight-yellow {
	color: rgb(223,171,1);
}
.highlight-teal {
	color: rgb(15,123,108);
}
.highlight-blue {
	color: rgb(11,110,153);
}
.highlight-purple {
	color: rgb(105,64,165);
}
.highlight-pink {
	color: rgb(173,26,114);
}
.highlight-red {
	color: rgb(224,62,62);
}
.highlight-gray_background {
	background: rgb(235,236,237);
}
.highlight-brown_background {
	background: rgb(233,229,227);
}
.highlight-orange_background {
	background: rgb(250,235,221);
}
.highlight-yellow_background {
	background: rgb(251,243,219);
}
.highlight-teal_background {
	background: rgb(221,237,234);
}
.highlight-blue_background {
	background: rgb(221,235,241);
}
.highlight-purple_background {
	background: rgb(234,228,242);
}
.highlight-pink_background {
	background: rgb(244,223,235);
}
.highlight-red_background {
	background: rgb(251,228,228);
}
.block-color-default {
	color: inherit;
	fill: inherit;
}
.block-color-gray {
	color: rgba(55, 53, 47, 0.6);
	fill: rgba(55, 53, 47, 0.6);
}
.block-color-brown {
	color: rgb(100,71,58);
	fill: rgb(100,71,58);
}
.block-color-orange {
	color: rgb(217,115,13);
	fill: rgb(217,115,13);
}
.block-color-yellow {
	color: rgb(223,171,1);
	fill: rgb(223,171,1);
}
.block-color-teal {
	color: rgb(15,123,108);
	fill: rgb(15,123,108);
}
.block-color-blue {
	color: rgb(11,110,153);
	fill: rgb(11,110,153);
}
.block-color-purple {
	color: rgb(105,64,165);
	fill: rgb(105,64,165);
}
.block-color-pink {
	color: rgb(173,26,114);
	fill: rgb(173,26,114);
}
.block-color-red {
	color: rgb(224,62,62);
	fill: rgb(224,62,62);
}
.block-color-gray_background {
	background: rgb(235,236,237);
}
.block-color-brown_background {
	background: rgb(233,229,227);
}
.block-color-orange_background {
	background: rgb(250,235,221);
}
.block-color-yellow_background {
	background: rgb(251,243,219);
}
.block-color-teal_background {
	background: rgb(221,237,234);
}
.block-color-blue_background {
	background: rgb(221,235,241);
}
.block-color-purple_background {
	background: rgb(234,228,242);
}
.block-color-pink_background {
	background: rgb(244,223,235);
}
.block-color-red_background {
	background: rgb(251,228,228);
}
.select-value-color-default { background-color: rgba(206,205,202,0.5); }
.select-value-color-gray { background-color: rgba(155,154,151, 0.4); }
.select-value-color-brown { background-color: rgba(140,46,0,0.2); }
.select-value-color-orange { background-color: rgba(245,93,0,0.2); }
.select-value-color-yellow { background-color: rgba(233,168,0,0.2); }
.select-value-color-green { background-color: rgba(0,135,107,0.2); }
.select-value-color-blue { background-color: rgba(0,120,223,0.2); }
.select-value-color-purple { background-color: rgba(103,36,222,0.2); }
.select-value-color-pink { background-color: rgba(221,0,129,0.2); }
.select-value-color-red { background-color: rgba(255,0,26,0.2); }

.checkbox {
	display: inline-flex;
	vertical-align: text-bottom;
	width: 16;
	height: 16;
	background-size: 16px;
	margin-left: 2px;
	margin-right: 5px;
}

.checkbox-on {
	background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%2358A9D7%22%2F%3E%0A%3Cpath%20d%3D%22M6.71429%2012.2852L14%204.9995L12.7143%203.71436L6.71429%209.71378L3.28571%206.2831L2%207.57092L6.71429%2012.2852Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E");
}

.checkbox-off {
	background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20x%3D%220.75%22%20y%3D%220.75%22%20width%3D%2214.5%22%20height%3D%2214.5%22%20fill%3D%22white%22%20stroke%3D%22%2336352F%22%20stroke-width%3D%221.5%22%2F%3E%0A%3C%2Fsvg%3E");
}
</style>